export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/imperfectionsIcon.5f2e6d19.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};